/**
 * Capacitor platform detection. Safe to use in web-only builds (Capacitor may not be installed).
 */

declare global {
  interface Window {
    Capacitor?: {
      isNativePlatform: () => boolean;
      getPlatform: () => string;
      Plugins?: Record<string, { [k: string]: (...args: unknown[]) => Promise<unknown> }>;
    };
  }
}

export function isCapacitorNative(): boolean {
  if (typeof window === 'undefined') return false;
  return Boolean(window.Capacitor?.isNativePlatform?.());
}

export function isNativeIOS(): boolean {
  if (typeof window === 'undefined') return false;
  return window.Capacitor?.getPlatform?.() === 'ios';
}

export function isNativeAndroid(): boolean {
  if (typeof window === 'undefined') return false;
  return window.Capacitor?.getPlatform?.() === 'android';
}

export function getNativePlatform(): 'ios' | 'android' | null {
  if (!isCapacitorNative()) return null;
  const p = window.Capacitor?.getPlatform?.();
  if (p === 'ios' || p === 'android') return p;
  return null;
}

/**
 * Standard for payment routing:
 * - Native iOS app (App Store): use Apple In-App Purchase (StoreKit).
 * - Native Android app (Play Store): use Google Play Billing (in-app).
 * - Web (desktop or mobile browser): use Stripe Checkout.
 * Use this when deciding whether to call Stripe or native IAP.
 */
export function shouldUseStripeCheckout(): boolean {
  if (typeof window === 'undefined') return true;
  const platform = window.Capacitor?.getPlatform?.();
  return platform !== 'ios' && platform !== 'android';
}
